import { OverviewTable } from "Components/Tables";
import { VoteTypeEnum } from "Enums";
import { FC } from "react";

export const ToOverview: FC = () => {
    return (
        <OverviewTable voteType={VoteTypeEnum.YesNoSuper} />
    );
};